import { Button } from '@design-system/Button';
import {
  Dialog,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@design-system/Dialog';
import { SMPDialogContent } from './SMPDialogContent';

interface SMPMutationErrorDialogProps {
  open: boolean;
  onClose: () => void;
  description?: string;
}

export const SMPMutationErrorDialog = ({
  open,
  onClose,
  description = 'Please try again or contact support if the issue persists.',
}: SMPMutationErrorDialogProps) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <SMPDialogContent className="md:max-w-[500px] items-start pt-12 pb-10 px-10">
      <DialogHeader className="gap-4 text-start">
        <DialogTitle className="typography-h3 text-primary">
          Something Went Wrong
        </DialogTitle>
        <DialogDescription className="typography-body text-secondary">
          {description}
        </DialogDescription>
      </DialogHeader>
      <Button
        onClick={onClose}
        data-testid="smp-errorDialog-tryAgain"
      >
        Try Again
      </Button>
    </SMPDialogContent>
  </Dialog>
);
